import { createFileRoute } from "@tanstack/react-router";
import { SinceCalculator } from "@/components/tools/SinceCalculator";

export const Route = createFileRoute("/tools/hari-ldr")({
  head: () => ({
    meta: [
      { title: "Kalkulator Lama LDR - Sudah Berapa Lama LDR-an?" },
      { name: "description", content: "Hitung sudah berapa lama kamu menjalani LDR (Long Distance Relationship) dengan pasangan. Tahun, bulan, hari." },
      { property: "og:title", content: "Kalkulator Lama LDR" },
      { property: "og:description", content: "Sudah berapa lama kamu LDR-an sama pasangan?" },
    ],
  }),
  component: () => (
    <SinceCalculator
      title="Kalkulator Lama LDR-an"
      intro="Sudah berapa lama kamu menjalani LDR (Long Distance Relationship) dengan pasangan? Hitung di sini supaya makin sabar menanti."
      dateLabel="Tanggal mulai LDR"
      verb="LDR-an"
      iconKey="since-ldr"
      storageKey="ldr"
      path="/tools/hari-ldr"
      body={[
        { heading: "Apa itu kalkulator lama LDR?", text: "Alat hitung berapa lama kamu menjalani hubungan jarak jauh. Cocok untuk pasangan yang terpisah karena kuliah, kerja, atau dinas." },
        { heading: "Cara pakai", text: "Masukkan tanggal kamu dan pasangan mulai LDR. Kami tampilkan total hari, breakdown tahun-bulan-hari, plus weton tanggal mulai LDR." },
        { heading: "Tips bertahan LDR", text: "Komunikasi rutin, agenda video call, dan tujuan jelas (kapan ketemu lagi) bantu LDR berhasil. Kalkulator ini bantu lihat seberapa jauh perjalanannya." },
      ]}
      faq={[
        { q: "Apakah ini sama dengan kalkulator hari jadian?", a: "Beda. Hari jadian dihitung dari awal pacaran. Kalkulator LDR dihitung dari tanggal kalian mulai jarak jauh - bisa setelah pacaran sebentar atau sudah lama." },
        { q: "Bagaimana cara LDR awet?", a: "Penelitian menunjukkan komunikasi konsisten, kepercayaan, dan target reuni terjadwal jadi kunci. Tapi setiap pasangan berbeda." },
        { q: "Apakah hasilnya bisa dibagikan?", a: "Ya. Klik 'Bagikan hasil' untuk salin link yang sudah berisi tanggal mulai LDR." },
        { q: "Bisa dipakai untuk LDR keluarga?", a: "Bisa. Tidak harus pasangan - LDR keluarga atau sahabat juga relevan." },
        { q: "Apakah data saya privat?", a: "Ya. Semua disimpan hanya di browser kamu (localStorage), bukan di server kami." },
      ]}
    />
  ),
});